import './heber/style';
import FormStructure from './heber/form_structure';

export default FormStructure;